
<template>
  <div>

    <div class="container-fluid">
      <div class="row ">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img class="img-fluid for-light" src="../assets/images/logo/login/logo.png" height="160" width="250" alt="looginpage" />
                  <img class="img-fluid for-dark" src="../assets/images/logo/login/logo_dark.png" height="160" width="250" alt="looginpage" />
                </a>
              </div>
              <div class="login-main">
                <form class="theme-form">
                  <h4>Sign in to vendor account</h4>
                  <p>Enter your email & password to login</p>
                  <div class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input class="form-control" type="email" required="" placeholder=""
                      v-model="email">
                      <span class="validate-error" v-if="!email || !validEmail(email)">{{
                        email.errormsg }}</span>

                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <div class="form-input position-relative">
                      <input class="form-control" type="password" name="login[password]" required=""
                        placeholder="*********" v-model="password">
                        <span class="validate-error" v-if="password.length < 7">
                        {{ password.errormsg}}
                      </span>

                      <!-- <div class="show-hide"><span class="show"> </span></div> -->
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="text-end mt-3">
                      <button class="btn btn-primary btn-block w-100" type="submit" @click.prevent="onSubmit">Sign
                        in</button>

                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>


export default {
  name: 'login',
  data() {
    return {

      email: "",
      password: "",   
      errors: {}, 
      token: "",

    };
  },

  created() {

  },

  methods: {

    // login() {
    //   if (!this.user.password.value || this.user.password.value.length < 7) {
    //     this.user.password.errormsg = 'min length 7'
    //   } else { this.user.password.errormsg = '' }

    //   if (!this.user.email.value) {
    //     this.user.email.errormsg = 'empty not allowed'
    //   } else if (!this.validEmail(this.user.email.value)) {
    //     this.user.email.errormsg = 'Valid email required.'
    //   }
    //   else {
    //     this.user.email.errormsg = ''
    //   }
    //   if (!this.user.email.errormsg && !this.user.password.errormsg && this.user.email.value != 'vendor1@bestdeals.com' || this.user.password.value != '1234567') {
    //     alert("wrong credenstials")
    //   }
    //   if (!this.user.email.errormsg && !this.user.password.errormsg && this.user.email.value == 'vendor1@bestdeals.com' && this.user.password.value == '1234567') {

    //     this.result = { email: this.user.email.value, password: this.user.password.value }

    //     localStorage.setItem('bestdeals_vendor', JSON.stringify({ email: this.user.email.value, useer: true }))
    //     this.logging = true
    //     this.$router.push('/')


    //   }
    // },
    validEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    submit() {
      this.$router.push({ name: "dashboard" });
    },

    onSubmit() {
        
        var data = JSON.stringify({
            "email": this.email,
            "password": this.password
        });

        const config = {
           headers: {
             "Content-Type": "application/json",
             "Accept": "application/json",
           },
        };

        this.errors = {};
        this.$axios
        .post("/login", data, config)
        .then((response) => {
           console.log(response);
           if(response.status == 200) {
              
            var responseData = response.data.data.details;
            
              console.log(responseData);
              if (responseData.token) {

                 localStorage.setItem('bestdeals_vendor', JSON.stringify(responseData));   
                 this.token = responseData.token;
                 this.$router.push({ name: "dashboard" });
                
                 this.$swal("", response.data.message, "success");        
              
              } else {
                 this.$swal("", "Failed to fetch token, please try again", "error");
              }
           }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) 
              {
                if(error.response.data.message.email)
                {
                  this.errors = error.response.data.message.email[0];
                  this.$swal("", error.response.data.message.email[0], "error");
                }
                else if(error.response.data.message.password)
                {
                  this.errors = error.response.data.message.password[0];
                  this.$swal("", error.response.data.message.password[0], "error");
                } 
                
              } else {
                this.$swal("", error.response.statusText, "error");
              }
              // this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 401) {
              this.$swal("", error.response.statusText, "error");
              this.$router.push({ name: "login" });
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        });
     //.finally(() => (this.loading = false));
    },

  },
};
</script>
